import React, { createContext, useContext } from 'react';
import { useAlerts } from '../hooks/useAlerts';
import AlertContainer from '../components/AlertContainer';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const alertMethods = useAlerts();

  return (
    <AlertContext.Provider value={alertMethods}>
      {children}
      <AlertContainer 
        alerts={alertMethods.alerts} 
        onRemove={alertMethods.removeAlert} 
      />
    </AlertContext.Provider>
  );
};

export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlertContext deve ser usado dentro de AlertProvider');
  }
  return context;
};
